export default __webpack_public_path__ + "static/media/icon_lock_group.b4dab1d4.svg";